import React from 'react';

import { LifeAreaSummaryHeader } from './components/life-area-summary-header/life-area-summary-header';
import { SummaryGoals } from './summary-goals';
import { Tasks } from './tasks';

export const Summary: React.FC = () => (
  <>
    <LifeAreaSummaryHeader />
    <SummaryGoals />
    <Tasks grow hasLink />
  </>
);
